export default __webpack_public_path__ + "static/media/single-staggered-border-both.ce685a7e.svg";